<template>
	<div v-if="cards || header" class="marketing-section bg-color-white">
		<div class="container pb-600-lg">
			<MarketingPageHeader
				v-if="header"
				:header="header"
				:is-secondary="true"
				class="pb-300 pb-500-md"
			></MarketingPageHeader>
			<MarketingSiteCardRow v-if="cards" :cards="cards" theme="light" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { LandingPageHeader } from 'types/layout';
import MarketingPageHeader from '@components/marketing-site/marketing-page-header.vue';
import { MarketingSiteCard } from 'types/marketing-site';
import MarketingSiteCardRow from '@components/marketing-site/marketing-site-card-row.vue';
import { SanityMarketingToutsPanel } from 'types/sanity/marketing-components';

interface Props {
	data: SanityMarketingToutsPanel;
}

const props = defineProps<Props>();

const header = computed((): LandingPageHeader | undefined => {
	if (!props.data.panelHeading) {
		return undefined;
	}

	return {
		title: props.data.panelOverline ?? '',
		heading: props.data.panelHeading,
		summary: props.data.panelSummary ? [props.data.panelSummary] : []
	};
});

const cards = computed((): Array<MarketingSiteCard> | undefined => {
	const toutsPanel = props.data.panelTouts;
	const marketingCards: Array<MarketingSiteCard> = [];

	if (toutsPanel && toutsPanel?.length) {
		toutsPanel.forEach((tout) => {
			marketingCards.push({
				title: tout.toutHeading || '',
				description: tout.toutSummary || '',
				link:
					tout.toutCta?.url && tout.toutCta?.linkText
						? {
								href: tout.toutCta?.url || undefined,
								target: tout.toutCta?.openInNewTab ? '_blank' : '_self',
								text: tout.toutCta?.linkText || undefined
							}
						: undefined
			});
		});
		return marketingCards;
	}
	return undefined;
});
</script>
